/* eslint-disable no-debugger */
import { map, filter } from 'lodash';
import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

const initialState = {
  isLoading: false,
  error: '',
  vendorMsg: '',
  status: true,
  createVendorStatus: false,
  vendorList: [],
  disableVendorList: [],
  moduleList: []
};

const slice = createSlice({
  name: 'vendor',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    // RESET MSG
    resetVendorMsg(state) {
      state.vendorMsg = '';
    },
    // RESET ERROR
    resetVendorError(state) {
      state.error = '';
    },
    // RESET CREATE STATUS
    resetCreateVendorStatus(state) {
      state.createVendorStatus = false;
    },
    // HAS ERROR
    hasError(state, action) {
      const { message } = action.payload?.data;
      state.createVendorStatus = false;
      state.isLoading = false;
      state.error = message;
    },
    // STATUS
    vendorStatus(state, action) {
      state.isLoading = false;
      state.status = action.payload;
    },
    // GET VENDOR LIST
    getVendorListSuccess(state, action) {
      state.isLoading = false;
      state.vendorList = action.payload;
    },
    // GET DISABLE VENDOR LIST
    getDisableVendorListSuccess(state, action) {
      state.isLoading = false;
      state.disableVendorList = action.payload;
    },
    // GET ALL MODULE LIST
    getAllModuleListSuccess(state, action) {
      const { permissions } = action.payload;
      state.isLoading = false;
      state.moduleList = permissions;
    },
    // CREATE VENDOR
    createVendorSuccess(state, action) {
      const newVendor = action.payload;
      state.createVendorStatus = true;
      state.isLoading = false;
      state.vendorList = [...state.vendorList, newVendor];
    },
    // UPDATE CLIENT
    updateVendorSuccess(state, action) {
      const vendor = action.payload;
      state.createVendorStatus = true;
      const updateVendor = map(state.vendorList, (_vendor) => {
        if (_vendor.id === vendor.id) {
          return vendor;
        }
        return _vendor;
      });
      state.isLoading = false;
      state.vendorList = updateVendor;
    },
    // FILTER VENDOR
    filterVendorSuccess(state, action) {
      const vendor = action.payload;
      state.isLoading = false;
      if (state.status) {
        state.vendorList = vendor;
      } else {
        state.disableVendorList = vendor;
      }
    },
    // DISABLE OR RESTORE VENDOR
    statusChangeSuccess(state, action) {
      if (action.payload.message) {
        state.vendorMsg = action.payload.message;
      } else {
        const { id } = action.payload;
        const vendorStatus = filter(
          state.status ? state.disableVendorList : state.vendorList,
          (vendor) => vendor.id !== id
        );
        state.isLoading = false;
        if (state.status) {
          state.createVendorStatus = false;
          state.vendorMsg = '';
          state.disableVendorList = vendorStatus;
        } else {
          state.createVendorStatus = true;
          state.vendorList = vendorStatus;
        }
      }
    },
    // DELETE VENDOR
    deleteVendorSuccess(state, action) {
      const { id } = action.payload;
      const deleteEvent = filter(state.disableVendorList, (vendor) => vendor.id !== id);
      state.isLoading = false;
      state.disableVendorList = deleteEvent;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const { resetCreateVendorStatus, resetVendorError, resetVendorMsg } = slice.actions;

// ----------------------------------------------------------------------

// GET ALL MODULE LIST GET
export function getAllModuleList() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'get',
        url: `http://smartcollect-api.cp360apps.com/cp360adminlogin/permission-list/`
      });
      dispatch(slice.actions.getAllModuleListSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// GET VENDOR LIST GET
export function getVendorList(status) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'get',
        url: `http://smartcollect-api.cp360apps.com/createvendor/vendor/filter/item/?status=${status}`
      });
      if (status) {
        dispatch(slice.actions.getVendorListSuccess(response.data));
      } else {
        dispatch(slice.actions.getDisableVendorListSuccess(response.data));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// CREATE VENDOR POST
export function createVendor(vendorData) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'post',
        url: 'http://smartcollect-api.cp360apps.com/createvendor/create-vendor/',
        data: vendorData
      });
      dispatch(slice.actions.createVendorSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// EDIT OR UPDATE VENDOR PUT
export function updateVendor(vendorData, id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'put',
        url: `http://smartcollect-api.cp360apps.com/createvendor/vendor-update/${id}/`,
        data: vendorData
      });
      dispatch(slice.actions.updateVendorSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// SEARCH AND FILTER VENDOR GET
export function filterVendor(pageStatus, name) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.vendorStatus(pageStatus));
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'get',
        url: `http://smartcollect-api.cp360apps.com/createvendor/vendor/filter/item/?vendor_name=${name}&status=${pageStatus}`
      });
      dispatch(slice.actions.filterVendorSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// DISABLING OR RESTORING OF PARTICULAR VENDOR PUT
export function statusChange(id, status) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.vendorStatus(status));
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'put',
        url: `http://smartcollect-api.cp360apps.com/createvendor/vendor/update-status-${status}/${id}/`
      });
      dispatch(slice.actions.statusChangeSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// DELETE VENDOR DELETE
export function deleteVendor(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'delete',
        url: `http://smartcollect-api.cp360apps.com/createvendor/delete/${id}/`
      });
      dispatch(slice.actions.deleteVendorSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// ----------------------------------------------------------------------
